import type { Board } from '../types';

export const mockBoards: Board[] = [
  {
    id: 'board-1',
    projectId: 'proj-1',
    tenantId: 'org-1',
    name: 'Development',
    description: 'Main development board',
    order: 0,
    statusCount: 4,
    createdAt: '2025-01-10T08:00:00Z',
  },
  {
    id: 'board-2',
    projectId: 'proj-1',
    tenantId: 'org-1',
    name: 'Design Review',
    description: 'Design review and approval workflow',
    order: 1,
    statusCount: 3,
    createdAt: '2025-01-11T09:00:00Z',
  },
  {
    id: 'board-3',
    projectId: 'proj-1',
    tenantId: 'org-1',
    name: 'QA & Testing',
    description: null,
    order: 2,
    statusCount: 3,
    createdAt: '2025-01-12T10:00:00Z',
  },
];
